export default "__VITE_ASSET__DOiF332D__"